import React from 'react';
import { Button } from '@material-ui/core';
import { ButtonDiv, ConfirmModalDiv, ModalText } from './WrapperDiv';
export const ConfirmModal = ({
  onOKClick,
  onCancelClick,
  okText,
  isOkDisabled,
  noText,
  isNoDisabled,
  modalText,
  hideCancel,
  okButtonColor,
  content,
  style
}) => /*#__PURE__*/React.createElement(ConfirmModalDiv, {
  style: style
}, /*#__PURE__*/React.createElement(ModalText, null, modalText), content && content || '', /*#__PURE__*/React.createElement(ButtonDiv, null, okText && /*#__PURE__*/React.createElement(Button, {
  title: okText,
  disabled: isOkDisabled,
  size: "small",
  variant: "contained",
  color: okButtonColor || 'primary',
  onClick: onOKClick
}, okText), !hideCancel && noText && /*#__PURE__*/React.createElement(Button, {
  title: noText,
  disabled: isNoDisabled,
  size: "small",
  variant: "contained",
  color: "primary",
  onClick: onCancelClick
}, noText)));
export default ConfirmModal;